import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=05b2e426&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"
import style0 from "./chart.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSparkline } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VLayout,VSparkline})
